import { getContext } from '@fiverr-private/fiverr_context';
import { FederatedSeller } from '../../types';
import { useSellerData } from '../useSellerData';

export const useIsCurrentUser = () => {
    const { sellerId } = useSellerData(selectSellerSlice);
    const { userId } = getContext();

    return userId?.toString() === sellerId?.toString();
};

function selectSellerSlice(seller: FederatedSeller) {
    return {
        sellerId: seller.user.id,
    };
}
